import { CarrierInfoFormState, CarrierInfoState } from '../types';

export const carrierInfoState: CarrierInfoState = {
  carrierInformation: [],
  // This will hold a carrier info data to be updated/deleted
  editDeleteCarrierInformation: null,
  // API request statuses
  isRequestPending: false,
  isDeleteCarrierInfoRequestPending: false,
  isCreateUpdateCarrierInfoRequestPending: false,
  // Toggle modal state
  isToggleCreateEditCarrierInfoModal: false,
  isToggleDeleteCarrierInfoModal: false,
};

export const carrierInfoFormState: CarrierInfoFormState = {
  carrierName: '',
  carrierDotNumber: '',
  street: '',
  city: '',
  state: { code: 'AL', name: 'Alabama' },
  country: { name: 'USA', code: 'USA' },
  zip: '',
  phoneNumber: '',
  timezone: { name: 'Central (CST6CDT)', code: 'CST6CDT' },
  startTimeOfDay: { name: '12 AM', code: '00:00:00.000' },
  isDefault: false,
};
